import React, { useState, useEffect } from 'react';
import { fetchDelay } from '../actions';
import moment from 'moment-timezone';
import ContainerInfo from './delayCertificates/ContainerInfo';
import DelayModal from './delayCertificates/DelayModal';
import { eventsEmit } from '../services/appboxService';

const DelayCertificates = () => {
  const [delays, setDelays] = useState([]);
  const [isOpen, setOpen]  = useState(false);
  const [dateLabel, setDateLabel]  = useState(null);
  const [slotLabel, setSlotLabel]  = useState(null);
  const [delayMinutes, setDelayMinutes]  = useState(null);

  const currentTime = moment();

  useEffect(() => {
      import('../assets/stylesheets/delay-certificate/index.css')
        .then(() => {
        })
        .catch(err => console.error("CSSの読み込みエラー", err));

      import('../assets/stylesheets/delay-certificate/detail.css')
        .then(() => {
        })
        .catch(err => console.error("CSSの読み込みエラー", err));

      async function fetchDelaysJson() {
        const now = moment();
        const after4am = now.hour() >= 4;
        // 04:00 以降になるまでは当日の遅延は表示しない
        const firstDate = after4am
          ? now.clone().startOf('day')
          : now.clone().startOf('day').subtract(1, 'day');

        const start = firstDate.clone().subtract(34, 'days'); // 35 日前
        const delaysJson = [];

        for (let d = firstDate.clone(); d.isSameOrAfter(start, 'day'); d.subtract(1, 'day')) {
          const delaysDate = d.format('YYYY-MM-DD');

          try {
            delaysJson.push(await fetchDelay(delaysDate));
          } catch (error) {
            // 取得失敗時はダミーを入れておく
            delaysJson.push({
              date: delaysDate,
              delay_minutes: [null, null, null],
              updated_at: null,
              manual: null,
            });
            console.error(`${delaysDate} の遅延情報の取得に失敗:`, error);
          }
        }

        console.log(delaysJson);
        setDelays(delaysJson);
      }

      fetchDelaysJson();
    }, []);

  return (
    <div>
      <main className={`tx-container${isOpen ? ' modal-open' : ''}`}>
        <div className="info-container">
          <p className="info-today">
            {currentTime.format('YYYY年M月D日 H時mm分')}時点の情報です。
          </p>
          <p>「-」の時間帯は遅延証明書の発行はありません。</p>
          <p>
            当証明書は「初電～10時」、「10時～17時」、「17時～終電」の時間帯別に掲出いたします。
            当証明書は当日を含む35日分の情報を掲出いたします。
          </p>
          <p>
            なお、遅延証明書の表示に時間がかかる場合がございます。
          </p>
        </div>

        <div className="tx-delay-container">
          {delays && delays.map((delay, index) => (
            <ContainerInfo
              key={`container-info-${index}`}
              delay={delay}
              setOpen={setOpen}
              setDateLabel={setDateLabel}
              setSlotLabel={setSlotLabel}
              setDelayMinutes={setDelayMinutes}
              parentIndex={index}
              currentTime={currentTime}
              eventsEmit={eventsEmit}
            />
          ))}
        </div>

        {isOpen && (
          <DelayModal
            onClose={() => setOpen(false)}
            dateLabel={dateLabel}
            slotLabel={slotLabel}
            delayMinutes={delayMinutes}
            issueDate={currentTime.locale('ja').format('YYYY年M月D日（ddd）')}
            eventsEmit={eventsEmit}
          />
        )}
      </main>
    </div>
  );
};

export default DelayCertificates;
